<template>
    <input 
        class="form-control" 
        type="tel" 
        placeholder="Phone" 
        pattern="^\d{3}-\d{3}-\d{4}$" 
        @keyup="verifyPhone"
        v-model="phone" 
        :readonly="readonly"
        :disabled="disabled"
    />
</template>

<script>

export default {
    props: {
        readonly: {
            type: Boolean,
            default: false
        },

        disabled: {
            type: Boolean,
            default: false
        },

        value: {
            type: String,
            default: '',
        }
    },

    data() {
        return {
            phone: this.value,
        }
    },

    mounted() {
        this.verifyPhone();
    },

    updated() {
        this.$emit('input', this.phone);
    },

    methods: {
        verifyPhone() {
            this.phone = this.phone.replace(/[^0-9]/g, '');
            this.phone = this.phone.substr(0, 10);
            
            if ( this.phone.length > 6 ) {
                let a = this.phone.substr(0, 3);
                let b = this.phone.substr(3, 3);
                let c = this.phone.substr(6);
                
                this.phone = `${a}-${b}-${c}`;
            } else if ( this.phone.length > 3 ) {
                let a = this.phone.substr(0, 3);
                let b = this.phone.substr(3);
                
                this.phone = `${a}-${b}`;
            }
        },
    }
}
</script>